import React, { useState, useEffect } from 'react';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toolbar } from 'primereact/toolbar';
import { Dropdown } from 'primereact/dropdown';
import AssuranceService from '../services/AssuranceService';
import { itemPerPage } from '../baseUrls/consts';

const PointAssurance = () => {
    const [items, setItems] = useState([]);
    const [globalFilter, setGlobalFilter] = useState('ASSURANCE_VALIDE');
    const [loading, setLoading] = useState(true);

    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(itemPerPage);

    const onPageChange = (event) => {
        setFirst(event.first);
        setRows(event.rows);
    };

    useEffect(() => {
        loadItems();
    }, []);

    const loadItems = () => {
        AssuranceService.getPointAssurance((data, status) => {
                setLoading(false);
                if(status) setItems(data);   
            },
            {status: globalFilter},
            {institutionId: 2}
        );
    }

    //alert(globalFilter)
    const choice = [
        {label: 'ASSURANCE VALIDE', value: 'ASSURANCE_VALIDE'},
        {label: 'ASSURANCE EXPIRÉE', value:'ASSURANCE_EXPIREE'},
        {label: 'VEHICULE NON ASSURÉ', value: 'VEHICULE_NON_ASSURE'}
    ]
   
    return (
        <>
            <h5>Point des assurances</h5>
            <Toolbar className="mb-4" 
                left={
                    <React.Fragment>
                        <span className="block mt-6 md:mt-0 p-input-icon-left mr-2">
                            <Dropdown value={globalFilter} options={choice} optionLabel="label"
                                onChange={(e) => setGlobalFilter(e.target.value)} 
                                placeholder="Sélectionner" />
                        </span>
                        <Button label="Actualiser" icon="pi pi-refresh" className="p-button-primry mr-2" 
                            onClick={()=>{setLoading(true); loadItems()}} />
                    </React.Fragment>
                }  />
                
                
            <DataTable dataKey="id" value={items} 
                paginator rows={itemPerPage} /*first={first}  
                totalRecords={120} rowsPerPageOptions={[5, 10, 20, 30]} onPageChange={onPageChange} */
                loading={loading} /* globalFilter={globalFilter} */ 
                responsiveLayout="scroll" emptyMessage="Aucune donnée disponible.">

                <Column field="id" header="Identifiant" hidden sortable />
                <Column field="vehicule.immatriculation" header="Véhicule" sortable />
                <Column field="dateDebut" header="Date Début assurance" sortable 
                    body={(item)=> new Date(item.dateDebut).toLocaleDateString()}/>
                <Column field="dateFin" header="Date fin assurance" sortable style={{fontWeight: 'bold'}} 
                    body={(item)=> new Date(item.dateFin).toLocaleDateString()}/>
                <Column field="montant" header="Montant" sortable body={item => item.montant?.toLocaleString()} />
                <Column field="numeroPolice" header="Numéro police" sortable />
                <Column field="typeAssurance.libelleTypeAssurance" header="Libellé type assurance" sortable />
                <Column field="tiers.nom" header="Nom tiers" sortable />
                <Column field="referenceCava" header="Reference CAVA" sortable />
                <Column field="numeroCava" header="Numéro CVA" sortable />
            </DataTable>
        </>
    );
}


export default PointAssurance;